<template>
  <div class="headers">
    <div class='logo'>
      <img src="../assets/logo.png" alt="" style="width:100%;height:60px;margin-top:10px;">
    </div>
    <div class="title">
       北京一脉阳光医学信息技术有限公司
    </div>
  </div>
</template>

<script>
export default {
  name: 'headers',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headers{
  width: 100%;
  height: 80px;
  background-color: rgba(255, 255, 255, 1);
}
.logo{
  display: inline-block;
  width: 100px;
  height: 80px;
  margin-left: 100px;
  line-height: 80px;
  float: left;
}
.title{
  display: inline-block;
  margin-left: 40px;
  float: left;
  line-height: 80px;
  color: #06255E;
  font-size:20px;
}
</style>
